import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, LoaderIcon } from 'lucide-react';
import { initMetaPixel, trackPageGracias } from '../utils/metaPixel';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/miKeNXnKoUZ4pNJ3m9H5UE/PNG-website-file-dark-Transparent-background.png';
const WHATSAPP_URL = 'https://group.wha.link/boA9Ae';
export function ThankYou() {
  const [countdown, setCountdown] = useState(2);
  useEffect(() => {
    initMetaPixel();
    trackPageGracias();
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = WHATSAPP_URL;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="w-full min-h-screen bg-navy font-inter flex flex-col items-center justify-center px-4" data-id="element-107">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5
    }} className="max-w-md w-full text-center" data-id="element-108">
        <img src={LOGO_URL} alt="Start Launching Creatives" className="w-40 md:w-52 mx-auto mb-8" data-id="element-109" />

        <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        delay: 0.2,
        type: 'spring',
        stiffness: 200
      }} data-id="element-110">
          <CheckCircleIcon className="w-20 h-20 text-[#25D366] mx-auto mb-6" data-id="element-111" />
        </motion.div>

        <h1 className="font-oswald text-3xl md:text-4xl font-bold text-white uppercase mb-4" data-id="element-112">
          Gracias por registrarte
        </h1>

        <p className="text-gray font-inter text-base md:text-lg leading-relaxed mb-8" data-id="element-113">
          Te estamos redirigiendo al canal de WhatsApp para que recibas el
          enlace de la clase.
        </p>

        <div className="flex items-center justify-center gap-3 mb-8" data-id="element-114">
          <LoaderIcon className="w-5 h-5 text-red animate-spin" data-id="element-115" />
          <p className="text-white font-oswald text-lg" data-id="element-116">
            Redirigiendo en{' '}
            <span className="text-red font-bold" data-id="element-117">{countdown}</span> segundo
            {countdown !== 1 ? 's' : ''}...
          </p>
        </div>

        <a href={WHATSAPP_URL} className="inline-flex items-center justify-center gap-2 text-[#25D366] font-inter text-sm underline underline-offset-4 hover:text-[#20bd5a] transition-colors" data-id="element-118">
          Si no eres redirigido, haz clic aquí
        </a>
      </motion.div>
    </div>;
}